import PolicyScreen from './PolicyScreen'

export default PolicyScreen
